import { env } from "config";
import { useAuth } from "hooks/useAuth";

const createFetch = (accessToken) => {
  return async (url, options = {}) => {
    try {
      const response = await fetch(url, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${accessToken}`,
        },
      });

      return response;
    } catch (error) {
      if (error.message && error.message.includes("Authentication required")) {
        throw error;
      }

      console.error("Authenticated fetch failed:", error);
      throw error;
    }
  };
};

export const entraApi = (accessToken) => {
  const fetch = createFetch(accessToken);

  return {
    getGroups: async () => {
      try {
        const groupsResponse = await fetch(`${env.gatewayUrl}/graph/group`, {
          method: "GET",
        });
        const groupList = await groupsResponse.json();
        return groupList;
      } catch (error) {
        console.error("Error during groups retrieval:", error);
      }
    },

    getUsers: async () => {
      try {
        const userResponse = await fetch(`${env.gatewayUrl}/graph/user`, {
          method: "GET",
        });
        const userList = await userResponse.json();
        return userList;
      } catch (error) {
        console.error("Error during users retrieval:", error);
      }
    },
    getModules: async () => {
      try {
        const moduleResponse = await fetch(`${env.gatewayUrl}/graph/modules`, {
          method: "GET",
        });
        const moduleList = await moduleResponse.json();
        return moduleList;
      } catch (error) {
        console.error("Error during modules retrieval:", error);
      }
    },
  };
};
